import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-professional-space',
  templateUrl: './professional-space.component.html',
  styleUrls: ['./professional-space.component.scss']
})
export class ProfessionalSpaceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
